var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkout-products" },
    [
      _vm._l(_vm.groups, function(group) {
        return _c("checkout-products-group", {
          key: group.id,
          attrs: { group: group, "cart-is-loading": _vm.cartIsLoading },
          on: { edit: _vm.edit }
        })
      }),
      _c(
        "modal",
        {
          attrs: { visible: _vm.editingOpened },
          on: {
            "on-close": function($event) {
              _vm.editingOpened = false
            }
          }
        },
        [
          _c("product-editor", {
            attrs: { params: _vm.productParams },
            on: {
              "on-close": function($event) {
                _vm.editingOpened = false
              }
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }